module.exports = __webpack_public_path__ + "static/img/background.0523d51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background.jpg
// module id = AS41
// module chunks = 1